import BasePage from "@PrivateArea/Scripts/Pages/BasePage";

export default class ProcessAssetDetailPage extends BasePage {
    public static async init() {
        await super.init();

        this.setAssetProfileRelationList();
        this.setModal();
        BasePage.updateAutospin();
    }

    private static setAssetProfileRelationList() {
        let assetShareButton = document.getElementById("AssetShareButton"),
            assetShareBox = document.getElementById("AssetShareBox"),
            body = document.getElementsByTagName("body")[0];

        if (assetShareButton) {
            assetShareButton.addEventListener("click", function () {
                if (assetShareBox && assetShareBox.classList.contains("hden")) {

                    if (!body.hasAttribute("data-overflow")) {
                        body.setAttribute("data-overflow", "");
                    }

                    assetShareBox.classList.remove("hden");
                }
            });
        }
    }

    private static setModal() {
        let gallery = document.getElementById("Gallery");
        if (gallery) {
            (<any>window).lightGallery(gallery, {
                download: false,
                thumbnail: true
            });
        }
    }
}